module.exports = __webpack_public_path__ + "static/media/ic_arrow_left.a2f0bf65.svg";